const doc = [({"da":({"js":({"tenants":({"select":({"choose_tenant":"Vælg tenant"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;